
import { Injectable } from '@angular/core';
import { retry } from 'rxjs/operators';
import { API_ENDPOINT } from '@core/configs';
import { SendDraftNotificationDTO, SendFinalNotificationDTO } from '@core/models/dto/notifications.dto';
import { ApiService } from '../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private readonly http: ApiService) {
  }

  getAll(optWithContent = false) {
    const withContent = '?with-content=true';
    return this.http.get(
      API_ENDPOINT.notifications.controller + API_ENDPOINT.notifications.getAll
        + (optWithContent ? withContent : ''),
    );
  }

  getDetail(id: number) {
    return this.http.get(
      API_ENDPOINT.notifications.controller + API_ENDPOINT.notifications.getDetail + id,
    );
  }

  sendTest(data: SendDraftNotificationDTO) {
    return this.http.post(
      API_ENDPOINT.notifications.controller + API_ENDPOINT.notifications.sendTest,
      data,
    );
  }

  sendFinal(data: SendFinalNotificationDTO) {
    return this.http.post(
      API_ENDPOINT.notifications.controller + API_ENDPOINT.notifications.sendFinal,
      data,
    ).pipe(retry(1));
  }

  getDetailSendInfo(notificationsId: number) {
    return this.http.get(
      API_ENDPOINT.notificationsDetail.controller + API_ENDPOINT.notificationsDetail.getByNotificationsId +
      notificationsId,
    );
  }

  async getListUserByRole(recipients: number[] = []) {
    return this.http.post(
      API_ENDPOINT.notifications.controller + API_ENDPOINT.notifications.getListUserByRole,
      { recipients },
    ).toPromise();
  }

  sendInQueue(data) {
    return this.http.post(
      API_ENDPOINT.notifications.controller + API_ENDPOINT.notifications.sendInQueue,
      data,
    );
  }

  getSendListUser() {
    return this.http.get(
      API_ENDPOINT.notifications.controller + API_ENDPOINT.notifications.getSendList
    );
  }
}
